module.exports = __webpack_public_path__ + "static/media/DJM-logo.572947c0.svg";